import Layout from '../components/layout/Layout';
import ConsolidadoNotas from '../components/calificaciones/consolidado/ConsolidadoNotas';
import ConsolidadoPorPeriodo from '../components/calificaciones/consolidado/ConsolidadoPorPeriodo';
import ConsolidadoGeneral from '../components/calificaciones/consolidado/ConsolidadoGeneral';

export const ConsolidadoNotasPage = () => {
    return ( <Layout children={ < ConsolidadoNotas /> } /> )
}

export const ConsolidadoPorPeriodoPage = () => {
    return ( <Layout children={ <ConsolidadoPorPeriodo /> } /> )
}

export const ConsolidadoGeneralPage = () => {
    return ( <Layout children={ <ConsolidadoGeneral /> } /> )
}
